export const BREAKPOINT_PROFILE_FOR_MOBILE = 'md';
export const MOBILE_GAMES_ICON_SIZE = 22;
